"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoadingBody_styles_1 = require("./LoadingBody.styles");
const styles_1 = require("../../styles");
const LoadingBody = (props) => {
    const { columns, pageSize = 10, hideHeaderRow = false } = props;
    const rows = react_1.default.useMemo(() => [...new Array(pageSize)], [pageSize]);
    return (react_1.default.createElement("tbody", null, rows.map((_, i) => (react_1.default.createElement(styles_1.StyledBodyRow, { key: i, disableHoverStyles: true, hideHeaderRow: hideHeaderRow }, columns.map((_, i) => {
        return (react_1.default.createElement(styles_1.StyledBodyCell, { key: i },
            react_1.default.createElement(LoadingBody_styles_1.LoadingCell, null)));
    }))))));
};
exports.default = react_1.default.memo(LoadingBody);
//# sourceMappingURL=LoadingBody.js.map